import axios from "axios";
import { API_URL } from "const/constants";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchAccountTermNotifications = async ({
  clientAccountDetailId,
  termNumber,
  clientId,
}) => {
  const res = await axios.get(`${API_URL}/notification/account-term`, {
    params: {
      clientAccountDetailId,
      termNumber,
      ...(clientId != null ? { clientId } : {}),
    },
    headers: authHeaders(),
  });
  const payload = res.data?.data ?? res.data ?? [];
  return Array.isArray(payload) ? payload : [];
};

export const fetchAccountTermNotificationCount = async (params) => {
  const items = await fetchAccountTermNotifications(params);
  return items.length;
};
